if (typeof UVA === "undefined") var UVA = {};
if (typeof UVA.wpwizard === "undefined") UVA.wpwizard = {};
UVA.wpwizard.activeWizards = [];

jQuery(function () {
    var con = false;
    if (typeof uva == "undefined") var uva = {};
    if (typeof uva.wizard == "undefined") uva.wizard = {};

    // Helper
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    // #strict
    uva.Helper = function (cfg) {
        this.config = jQuery.extend({}, cfg);
        this.debug = typeof CONST_UVA_HELPER_DEBUG !== "undefined" ? CONST_UVA_HELPER_DEBUG : false;
    };

    // #strict
    uva.Helper.prototype.l = function (o) {
        var el;
        if (this.debug !== true) return;
        if (typeof console !== "undefined" && typeof console.log !== "undefined") {
            con && console.log(o);
            return;
        }
        el = jQuery("#uva-log");
        if (!el || el.length < 1) {
            el = jQuery('<ul style="display: none;" id="uva-log"></ul>');
            jQuery("body").append(el);
        }
        el.append("<li>" + String(o) + "</li>");
    };

    // #strict
    uva.Helper.prototype.trigger = function (eventname, wizard) {
        wizard.el.trigger(eventname);
    };

    // #strict
    uva.Helper.prototype.on = function (eventname, wizard) {
        var self = this;

        this.l(`event created '${eventname}' '${wizard.config.id}'`);
        con && console.log(`event created '${eventname}' '${wizard.config.id}'`);
        wizard.el.on(eventname, function () {
            self.l(`event fired '${eventname}' '${wizard.config.id}'`);
            con && console.log(`event fired '${eventname}' '${wizard.config.id}'`);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: `${eventname}`,
                wizard: `${wizard.config.id}`,
            });
        });
    };
    // Router
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    // #strict
    uva.wizard.Router = function (cfg) {
        this.h = new uva.Helper({});
        this.h.l("[UW-Trace]: Start Router::constructor");
        this.config = jQuery.extend(
            {
                routing: [],
                wizard: null,
            },
            cfg
        );
        this.history = [];
        this.h.l("[UW-Trace]: End Router::constructor");
    };

    // #strict
    uva.wizard.Router.prototype._addToHistory = function (id, data = [], weight = 0, taxonomy = "", description = "") {
        this.h.l("[UW-Trace]: Start Router::_addToHistory");
        const d = {
            id: id,
            data: data,
            weight: weight,
            taxonomy: taxonomy,
            description: description,
        };

        this.history.push(d);
        this.h.l("+ + + + + + + + + + Current history + + + + + + + + + +");
        this.h.l(this.history);
        this.h.l("[UW-Trace]: End Router::_addToHistory");
    };

    // #strict
    uva.wizard.Router.prototype._addPropertiesToHistoryById = function (id, data, weight, taxonomy, description) {
        this.h.l("[UW-Trace]: Start Router::_addPropertiesToHistoryById");
        this.history.forEach((e) => {
            if (e.id == id) {
                e.data = data;
                e.weight = weight;
                e.taxonomy = taxonomy;
                e.description = description;
            }
        });
        this.h.l("+ + + + + + + + + + Current history + + + + + + + + + +");
        this.h.l(this.history);
        this.h.l("[UW-Trace]: End Router::_addPropertiesToHistoryById");
    };

    // #strict
    uva.wizard.Router.prototype.getHistoryWeight = function () {
        var weight = 0;

        this.h.l("[UW-Trace]: Start Router::getHistoryWeight");
        this.history.forEach((e) => {
            weight = weight + e.weight;
        });
        this.h.l("+ + + + + + + + + + Current history + + + + + + + + + +");
        this.h.l(this.history);
        this.h.l("[UW-Trace]: End Router::getHistoryWeight");

        return weight;
    };

    // #strict
    uva.wizard.Router.prototype.getHistoryById = function (id) {
        var h = null;

        this.h.l("[UW-Trace]: Start Router::getHistoryById");
        this.history.forEach((e) => {
            if (id == e.id) h = e;
        });
        this.h.l("+ + + + + + + + + + Current history + + + + + + + + + +");
        this.h.l(this.history);
        this.h.l("[UW-Trace]: End Router::getHistoryById");

        return h;
    };

    // #strict
    uva.wizard.Router.prototype._autoRoute = function (forward = true) {
        this.h.l(`[UW-Trace]: Start Router::_autoRoute, forward: ${forward}`);
        var currentPage = this.getCurrentPage(),
            self = this,
            r;

        r = false;
        this.config.wizard.config.autoroute.forEach((e) => {
            if (e.id === currentPage.id) {
                self.h.l(`[UW-Trace]: - Found autoroute for page ${currentPage.id}, set value: ${e.trigger}`);

                forward && currentPage.setValue(e.trigger), self.routeForward();
                !forward && self.routeBackward();

                self.h.l(`[UW-Trace]: End Router::_autoRoute, forward: ${forward}`);
                r = true;
            }
        });
        if (r) return;

        this.h.l("[UW-Trace]: - No autoroute found for page " + currentPage.id);
        this.h.l(`[UW-Trace]: End Router::_autoRoute, forward: ${forward}`);
    };

    // #strict
    uva.wizard.Router.prototype._Dispatcher = function (forward = true) {
        this.h.l(`[UW-Trace]: Start Router::_Dispatcher, forward: ${forward}`);
        var currentPage = this.getCurrentPage(),
            self = this,
            r,
            weight = this.getHistoryWeight(),
            operation = {
                "==": function (x, y) {
                    return x == y;
                },
                ">": function (x, y) {
                    return x > y;
                },
                "<": function (x, y) {
                    return x < y;
                },
                ">=": function (x, y) {
                    return x >= y;
                },
                "<=": function (x, y) {
                    return x <= y;
                },
                "!=": function (x, y) {
                    return x != y;
                },
            };

        r = false;
        this.config.wizard.config.dispatcher.forEach((e) => {
            self.h.l(`[UW-Trace]: End Router::_Dispatcher, ID: ${e.id}, forward: ${forward}`);
            if (e.id === currentPage.id && operation[e.op](weight, e.weight)) {
                self.h.l(`[UW-Trace]: - Found dispatcher for page ${currentPage.id}`);

                forward && self.routeForward(true, e.target, false);
                !forward && self.routeBackward(false);

                self.h.l(`[UW-Trace]: End Router::_Dispatcher, forward: ${forward}`);
                r = true;
            }
        });
        if (r) return;

        this.h.l("[UW-Trace]: - No dispatcher found for page " + currentPage.id);
        this.h.l(`[UW-Trace]: End Router::_Dispatcher, forward: ${forward}`);
    };

    // #strict
    uva.wizard.Router.prototype._getLastFromHistory = function () {
        return this.history == [] ? null : this.history.slice(-1)[0];
    };

    // #strict
    uva.wizard.Router.prototype._removeLastFromHistory = function () {
        this.h.l("[UW-Trace]: Start Router::_removeLastFromHistory");
        this.history.pop();
        this.h.l("+ + + + + + + + + + Current history + + + + + + + + + +");
        this.h.l(this.history);
        this.h.l("[UW-Trace]: End Router::_removeLastFromHistory");
    };

    // #strict
    uva.wizard.Router.prototype.getCurrentPage = function () {
        this.h.l("[UW-Trace]: get last from history ...");
        return this._getLastFromHistory() ? this.config.wizard.getPage(this._getLastFromHistory().id) : null;
    };

    // #strict
    uva.wizard.Router.prototype.getNextEntries = function (currentPage) {
        var self = this;

        this.h.l("[UW-Trace]: Start Router::getNextEntries");
        if (!currentPage) {
            this.h.l("[UW-Warn]: - No current page given. Probably on first page?");
            return null;
        }
        var _currentvalue = currentPage.getValue();

        this.h.l("[UW-Trace]: - Current page: " + currentPage.id);
        this.h.l("[UW-Trace]: - Current value: ");
        this.h.l(_currentvalue);

        var entries = [];

        function pushFoundedEntry(e) {
            if (e.trigger !== currentPage.id) return;
            self.h.l("[UW-Trace]: - Founded matching 'trigger'. Looking for 'value' ... ");
            self.h.l(e.trigger);
            self.h.l("+ + + + + + _currentvalue + + + + + +");
            self.h.l(_currentvalue);
            if (Array.isArray(_currentvalue) && !_currentvalue.length) return;
            if (e.value && e.value.toString() !== "*") {
                var r = false,
                    values = JSON.parse(_currentvalue);
                values.forEach((arr) => {
                    if (e.value.toString() === arr.value.toString()) r = true;
                });
                if (!r) return;
            }
            self.h.l("[UW-Trace]: - ... founded matching 'value' " + e.value);
            entries.push(e);
        }

        this.config.routing.forEach(pushFoundedEntry);

        this.h.l("[UW-Trace]: Founded and pushed " + entries.length + " entries to 'routing'.");
        this.h.l("[UW-Trace]: End Router::getNextEntries");
        return entries;
    };

    // #strict
    uva.wizard.Router.prototype.isFirstPage = function () {
        return this.history.length === 1;
    };

    // #strict
    uva.wizard.Router.prototype.routeForward = function (skip = false, target = "", breadcrumb = true) {
        var we = { continue: true },
            self = this,
            r,
            breakPoint;

        this.h.l("[UW-Trace]: Start Router::routeForward");
        this.config.wizard.el.trigger("uw:beforerouteforward", [this.config.wizard, we]);
        if (we.continue === false) {
            this.h.l("[UW-Trace]: - Stop routing by event handler.");
            return;
        }
        var nextEntries = [],
            currentPage = this.getCurrentPage(),
            nextPage,
            nextFinisher;

        if (this.history.length === 0) {
            nextPage = this.config.wizard._getFirstPage();
            nextEntries = [
                {
                    target: nextPage.id,
                },
            ];
        } else {
            nextEntries = this.getNextEntries(currentPage);
        }

        if (skip) {
            if (currentPage !== null) {
                nextEntries = [
                    {
                        target: target != "" ? target : currentPage.el.data("page-target"),
                    },
                ];
            }
        }
        if (nextEntries.length < 1) {
            this.h.l("[UW-Error]: - No next entries found");
            return false;
        }

        // Check, if one of the next pages are not loaded
        r = false;
        nextEntries.forEach((e) => {
            if (e.target != "") {
                nextPage = this.config.wizard.getPage(e.target);

                this.h.l(nextPage);
                this.h.l(nextEntries);
                if (nextPage && !nextPage.isLoaded()) r = true;
            }
        });
        if (r) return;

        if (currentPage) {
            currentPage.hide("out-left");
            currentPage.setPrevious();
            this._addPropertiesToHistoryById(
                currentPage.id,
                currentPage.getValue(),
                currentPage.getWeight(),
                currentPage.getTaxonomyString(),
                currentPage.getDescription()
            );
            this.h.l("[UW-Trace]: - Routing from " + currentPage.id);
        }

        //-- Execute non-dying finishers --
        nextEntries.forEach((e) => {
            nextFinisher = self.config.wizard.getFinisher(e.target);
            if (nextFinisher && !nextFinisher.config.finishWorkflow) {
                self.h.l("[UW-Trace]: - Execute non-dying finisher " + nextFinisher.id);
                nextFinisher.finish();
                self.h.l("+ + + + + + + + + + Object: nextFinisher + + + + + + + + + +");
                self.h.l(nextFinisher);

                self.config.wizard.displaynavigationarray.forEach(function (a) {
                    self.config.wizard.displayNavigationContainerElement(a[0], !nextFinisher.config[a[1]]);
                });

                // this.config.wizard.displayNavigationContainerElement("previous", !nextFinisher.config.hidePreviousButton);
                // this.config.wizard.displayNavigationContainerElement("next", !nextFinisher.config.hideNextButton);
                // this.config.wizard.displayNavigationContainerElement("skip", !nextFinisher.config.hideSkipButton);
                // this.config.wizard.displayNavigationContainerElement("reset", !nextFinisher.config.hideResetButton);
                // this.config.wizard.displayNavigationContainerElement("submit", !nextFinisher.config.hideSubmitButton);
                // this.config.wizard.displayNavigationContainerElement("navigation-text", !nextFinisher.config.hideNavigationText);
            }
        });

        r = false;
        //-- Execute dying finishers --
        nextEntries.forEach((e) => {
            nextFinisher = self.config.wizard.getFinisher(e.target);
            if (nextFinisher && nextFinisher.config.finishWorkflow) {
                self.h.l("[UW-Trace]: - Execute dying finisher " + nextFinisher.id);
                self.h.l("+ + + + + + + + + + Object: nextFinisher + + + + + + + + + +");
                nextFinisher.finish();
                self.h.l(nextFinisher);

                self.config.wizard.displaynavigationarray.forEach(function (a) {
                    self.config.wizard.displayNavigationContainerElement(a[0], !nextFinisher.config[a[1]]);
                });

                // this.config.wizard.displayNavigationContainerElement("previous", false);
                // this.config.wizard.displayNavigationContainerElement("next", false);
                // this.config.wizard.displayNavigationContainerElement("skip", false);
                // this.config.wizard.displayNavigationContainerElement("reset", !nextFinisher.config.hideResetButton);
                // this.config.wizard.displayNavigationContainerElement("submit", false);
                // this.config.wizard.displayNavigationContainerElement("navigation-text", false);

                r = true; //Finished with workflow!!!
                this.config.wizard.config.renderTo.find(`#wizard-breadcrumb`).hide();
                this.config.wizard.config.renderTo.find(`#wizard-indicators`).hide();
                this.config.wizard.config.renderTo.find(`#wizard-navigation`).hide();
                con && console.log(`show-${nextFinisher.id}`);
                this.config.wizard.el.trigger(`show-${nextFinisher.id}`);
            }
        });

        if (r) return;

        //-- Execute pages --
        breakPoint = false;
        nextEntries.forEach((e) => {
            nextPage = this.config.wizard.getPage(e.target);

            if (nextPage && !breakPoint) {
                this.h.l("[UW-Trace]: - Routing to page " + nextPage.id);
                nextPage.setNext();
                nextPage.show("right");
                this._addToHistory(nextPage.id);
                breakPoint = true; //We only show one page
                con && console.log(`show-${nextPage.id}`);
                this.config.wizard.el.trigger(`show-${nextPage.id}`);
            }
        });

        this.config.wizard.el.trigger("uw:afterrouteforward", [this.config.wizard, breadcrumb]);

        this.h.l("[UW-Trace]: End Router::routeForward");
        this._autoRoute(true);
        this._Dispatcher(true);
        this.config.wizard.scrollTop();
    };

    // #strict
    uva.wizard.Router.prototype.routeBackward = function (breadcrumb = true) {
        this.h.l("[UW-Trace]: Start Router::routeBackward");
        var we = {
            continue: true,
        };
        this.config.wizard.el.trigger("uw:beforeroutebackward", [this.config.wizard, we]);
        if (we.continue === false) {
            this.h.l("[UW-Trace]: - Stop routing by event handler.");
            return;
        }
        var currentPage,
            previousPage,
            jQueryprevPrevIndex,
            prevPreviousPage,
            noHistory = this.history.length === 0;

        if (noHistory) {
            this.h.l("[UW-Warn]: - Already on first page, further back not possbile");
            return true;
        }

        currentPage = this.config.wizard.getPage(this.history[this.history.length - 1].id);
        currentPage.hide("out-right");

        this._removeLastFromHistory();
        previousPage = this.config.wizard.getPage(this.history[this.history.length - 1].id);
        previousPage.show("left");

        //-- Prepare the page before the previous page --
        jQueryprevPrevIndex = this.history.length - 2;
        if (jQueryprevPrevIndex > -1 && this.history[jQueryprevPrevIndex]) {
            prevPreviousPage = this.config.wizard.getPage(this.history[jQueryprevPrevIndex].id);
            prevPreviousPage.setPrevious();
        }

        this.config.wizard.el.trigger("uw:afterroutebackward", [this.config.wizard, breadcrumb]);

        this._autoRoute(false);
        this._Dispatcher(false);
        this.config.wizard.scrollTop();
    };

    // Finisher
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    // #strict
    uva.wizard.Finisher = function (cfg) {
        this.h = new uva.Helper({});
        this.h.l("[UW-Trace]: Start Finisher::constructor");
        this.config = jQuery.extend(
            {
                id: "",
                type: "finisher",
                finishertype: "simple", //'custom', 'form-submit', //ajax-form, //html
                finisherfunction: "",
                finisherHistory: false,
                finisherHistoryId: "",
                router: null,
                wizard: null,
                finishWorkflow: true,
                attributes: {
                    simple: {},
                    redirect: {
                        target: "#",
                    },
                    "form-submit": {
                        action: "#",
                        method: "POST",
                    },
                    "ajax-form": {
                        action: "#",
                        method: "POST",
                    },
                    html: {
                        content: "",
                        contentEl: null,
                    },
                },
            },
            cfg
        );
        this.id = this.config.id;
        this.h.l("[UW-Trace]: End Finisher::constructor");
    };

    // #strict
    uva.wizard.Finisher.prototype._submitAjaxFinish = function () {
        let self = this,
            data_session = typeof jQuery(`body`).data("session") !== "undefined" ? jQuery(`body`).data("session") : "",
            breadcrumb = this.config.router.history.slice(-1),
            classname = `wizard-breadcrumb-item breadcrumb-item`;

        breadcrumb = JSON.parse(breadcrumb[0].data);

        this.h.l("++++++++++++++++++++ APPEND uva_wizard_history ++++++++++++++++++++");

        // additional configuration for arguments array (tax_query ...)
        this.config.wizard.el.append(
            '<input name="uva_wizard_query" type="hidden" value=\'' + this.config.query + "' />"
        );

        this.config.wizard.el.append(
            '<input name="uva_wizard_history" type="hidden" value=\'' +
                JSON.stringify(this.config.router.history) +
                "' />"
        );
        this.config.wizard.el.append(
            '<input name="uva_wizard_data_session" type="hidden" value=\'' + data_session + "' />"
        );
        this.config.wizard.setLoading(true);
        this.h.l("++++");
        this.h.l("++++");
        this.h.l(this.config.wizard.el);

        jQuery
            .ajax({
                url: this.config.attributes["ajax-form"].action,
                type: this.config.attributes["ajax-form"].method,
                dataType: "html",
                data: this.config.wizard.el.serialize(),
                context: this.config.wizard.el,
                error: function (responseData, textStatus, errorThrown) {
                    // TODO: 404 error handling
                    // self.config.wizard.setLoading(true);
                    self.h.l(textStatus);
                    self.h.l(responseData);
                    self.h.l(errorThrown);
                },
            })
            .done(function (html) {
                self.config.wizard.setLoading(false);
                self.config.wizard.el.find(`#wizard-navigation`).before(html);
            });

        // Breadcrumbs start
        this.h.l("####### Breadcrumbs ######");

        if (breadcrumb[0].breadcrumb !== "undefined") {
            this.config.wizard.config.renderTo
                .find("#wizard-breadcrumb")
                .append(
                    `<li class="${classname} ${this.config.wizard.config.breadcrumbCss}">${breadcrumb[0].breadcrumb}</li>`
                );
        }
        this.config.wizard.config.renderTo
            .find("#wizard-breadcrumb li")
            .off("click", jQuery.proxy(this.config.wizard.breadcrumbpreviousPage, this.config.wizard));
        this.config.wizard.config.renderTo.find("#wizard-breadcrumb li").removeClass(`link`);
        // if appended item is hidden
        this.config.wizard.config.renderTo.find("#wizard-breadcrumb li").last().show();
        // Breadcrumbs end

        this.config.wizard.config.renderTo.find(`div[id^="wizard-indicators-custom-"]`).hide();

        return !this.config.finishWorkflow;
    };

    // #strict
    uva.wizard.Finisher.prototype._submitAjaxFinishNoHtml = function () {
        let self = this;
        this.h.l("++++++++++++++++++++ _submitAjaxFinishNoHtml ++++++++++++++++++++");
        this.h.l("++++++++++++++++++++ ajax-form ++++++++++++++++++++");
        this.h.l(this.config.attributes["ajax-form"]);
        this.h.l("++++++++++++++++++++ APPEND uva_wizard_history ++++++++++++++++++++");
        this.config.wizard.el.append(
            '<input name="uva_wizard_history" type="hidden" value=\'' +
                JSON.stringify(this.config.router.history) +
                "' />"
        );
        this.h.l("++++++++++++++++++++ el ++++++++++++++++++++");
        this.h.l(this.config.wizard.el);
        this.h.l("++++++++++++++++++++ serialize ++++++++++++++++++++");
        this.h.l(this.config.wizard.el.serialize());
        this.h.l("++++++++++++++++++++ unserialize ++++++++++++++++++++");

        function unserialize(serializedData) {
            let urlParams = new URLSearchParams(serializedData); // get interface / iterator
            let unserializedData = {}; // prepare result object
            for (let [key, value] of urlParams) {
                // get pair > extract it to key/value
                unserializedData[key] = value;
            }

            return unserializedData;
        }

        if (this.config.attributes["ajax-form"]) {
            this.h.l(unserialize(this.config.wizard.el.serialize()));
            jQuery
                .ajax({
                    url: this.config.attributes["ajax-form"].action,
                    type: this.config.attributes["ajax-form"].method,
                    dataType: "html",
                    data: unserialize(this.config.wizard.el.serialize()),
                    context: this.config.wizard.el,
                    error: function (responseData, textStatus, errorThrown) {
                        // TODO: 404 error handling
                        // self.config.wizard.setLoading(true);
                        self.h.l(textStatus);
                        self.h.l(responseData);
                        self.h.l(errorThrown);
                    },
                })
                .done(function (html) {
                    self.config.wizard.setLoading(false);
                });
        }
    };

    // #strict
    uva.wizard.Finisher.prototype._submitFinish = function () {
        this.config.wizard.el.attr("action", this.config.attributes["form-submit"].action);
        this.config.wizard.el.attr("method", this.config.attributes["form-submit"].method);
        this.config.wizard.el.append(
            '<input name="uva_wizard_history" type="hidden" value=\'' +
                JSON.stringify(this.config.router.history) +
                "' />"
        );
        this.config.wizard.el.submit();

        return !this.config.finishWorkflow;
    };

    // #strict
    uva.wizard.Finisher.prototype._redirectFinish = function () {
        window.location.href = this.config.attributes.redirect.target;

        return !this.config.finishWorkflow;
    };

    // #strict
    uva.wizard.Finisher.prototype._htmlFinish = function () {
        var divEl = jQuery(
            `<div id="wizard-finisher-${this.config.id}" class="wizard-finisher ${this.config.pageCss}"></div>`
        );

        this.h.l("++++++++++++++++++++ _htmlFinish ++++++++++++++++++++");
        this.h.l(divEl);

        this._submitAjaxFinishNoHtml();
        // this.config.wizard.el.html("").append(divEl.html(this.config.attributes.html.content));
        this.config.wizard.el.html("").append(divEl.append(this.config.attributes.html.contentEl));
        return !this.config.finishWorkflow;
    };

    // #strict
    uva.wizard.Finisher.prototype._simpleFinish = function () {
        let content = "";
        content += "<h2>Results:</h2>";
        content += '<ul class="wizard-answers">';
        this.config.router.history.forEach((e, i) => {
            content += `<li><label style="font-weight: bold;">Step ${String(i + 1)} (${e.id}): </label><p>${String(
                e.data
            )}</p></li>`;
        });
        content += "</ul>";
        this.config.wizard.el.html(content);
        return !this.config.finishWorkflow;
    };

    // #strict
    uva.wizard.Finisher.prototype.finish = function () {
        this.h.l("[UW-Trace]: Start Finisher::finish");
        var keys_and_values = [],
            we = {
                continue: true,
            };

        function stripslashes(str) {
            str = str.replace(/\\'/g, "'");
            str = str.replace(/\\"/g, '"');
            str = str.replace(/\\\\/g, "\\\\");
            str = str.replace(/\\/g, "\\");
            return str;
        }

        this.config.finisherHistory &&
            $(`#${this.config.finisherHistoryId}`).data("history", JSON.stringify(this.config.router.history));
        this.config.router.history.forEach((e) => {
            var data = e.data;

            data = typeof data === "string" ? JSON.parse(data) : data;

            data &&
                data.forEach((d) => {
                    var object = {},
                        key = `${d.key}`,
                        value = `${d.value}`;

                    key = key.indexOf("c-") == 0 ? key.substring(2, key.lastIndexOf("-")) : key;
                    object[key] = [];
                    object[key].push(value);

                    keys_and_values.push(object);
                });
        });

        con && console.log(keys_and_values);

        var result = {};
        keys_and_values.forEach((o) => {
            var key = Object.keys(o)[0],
                value = Object.values(o)[0];

            if (typeof result[key] === "undefined") result[key] = [];
            result[key].push(value);
        });

        keys_and_values = result;
        con && console.log(keys_and_values);

        this.config.finisherHistory &&
            $(`#${this.config.finisherHistoryId}`).data("json", JSON.stringify(keys_and_values));

        this.config.wizard.el.trigger("uw:beforefinish", [this.config.wizard, this, we]);
        this.config.wizard.scrollTop();

        if (we.continue === false) {
            this.h.l("[UW-Trace]: - Stop routing by event handler.");
            return;
        }

        let customFnName = this.config.finisherfunction;

        if (this.config.finishertype == "simple") return this._simpleFinish();
        if (this.config.finishertype == "redirect") return this._redirectFinish();
        if (this.config.finishertype == "form-submit") return this._submitFinish();
        if (this.config.finishertype == "ajax-form") return this._submitAjaxFinish();
        if (this.config.finishertype == "html") return this._htmlFinish();

        //-- Custom finisher --
        if (this.config.finishertype == "custom") {
            var customFn = typeof customFnName === "function" ? customFnName : window[customFnName];
            if (typeof customFn === "function") {
                this.h.l("[UW-Trace]: Call custom finisher function: " + customFnName);
                customFn(this.config.wizard);
            } else {
                this.h.l("[UW-Error]: Custom finisher function not found: " + customFnName);
            }
        }
        this.h.l("[UW-Trace]: End Finisher::finish");
    };

    // Page
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    // #strict
    uva.wizard.Page = function (cfg) {
        this.h = new uva.Helper({});
        this.h.l("[UW-Trace]: Start Page::constructor");

        this.events = [
            { type: `button`, on: [`click`] },
            { type: `textfield`, on: [`input`] },
            { type: `radio`, on: [`click`] },
            { type: `checkbox`, on: [`click`] },
            { type: `select`, on: [`change`] },
            // muss entfernt sein, da sonst keine validierung erfolgt und finisher triggert, ohne dass formulardaten abgeschickt werden
            // { type: `contact-form`, on: [`click`] },
        ];

        this.config = jQuery.extend(
            {
                id: "",
                type: "page",
                src: "",
                method: "GET",
                contentSelector: "",
                triggerType: "",
                triggerSelector: ["button"],
                triggerAttribute: "value",
                router: null,
                wizard: null,

                breadcrumb: "",
                stage: "",
                stageMax: "",

                hideNextButton: false,
                hideSkipButton: false,
                hideResetButton: false,
                hideSubmitButton: false,
                hidePreviousButton: false,
                hideNavigationText: false,

                customNextButton: false,
                customSkipButton: false,
                customResetButton: false,
                customSubmitButton: false,
                customPreviousButton: false,
                customNavigationText: false,

                customNavigation: false,

                navigation: {
                    nextButton: "",
                    skipButton: "",
                    resetButton: "",
                    submitButton: "",
                    previousButton: "",
                    navigationText: "",

                    nextCss: "",
                    skipCss: "",
                    resetCss: "",
                    submitCss: "",
                    previousCss: "",
                    navigationTextCss: "",

                    containerPreviousCss: "",
                    containerSkipCss: "",
                    containerResetCss: "",
                    containerSubmitCss: "",
                    containerNextCss: "",
                    containerNavigationTextCss: "",

                    defaultNextCss: "",
                    defaultSkipCss: "",
                    defaultResetCss: "",
                    defaultSubmitCss: "",
                    defaultPreviousCss: "",
                    defaultNavigationTextCss: "",

                    defaultContainerPreviousCss: "",
                    defaultContainerSkipCss: "",
                    defaultContainerResetCss: "",
                    defaultContainerSubmitCss: "",
                    defaultContainerNextCss: "",
                    defaultContainerNavigationTextCss: "",

                    containerCustomCss: "",
                },

                description: "",
                forwardOnClick: false,
                multiValue: false,
                allowClasses: false,

                attributes: {
                    button: { forwardOnClick: true, multiValue: false },
                    textfield: { forwardOnClick: false, multiValue: true },
                    textarea: { forwardOnClick: false, multiValue: true },
                    radio: { forwardOnClick: true },
                    checkbox: { forwardOnClick: false, multiValue: true },
                    select: { forwardOnClick: false },
                },
                forceReload: false,
            },
            cfg
        );

        this._tmpValue = [];
        this._tmpWeight = 0;
        this._tmpTaxonomyString = "";
        this._tmpDescription = "";
        this.loaded = false;
        this.el = null;
        this.id = this.config.id;

        this.h.l("[UW-Trace]: End Page::constructor");

        this.h.l(
            "|||||||||||||||||||||||||||||||||||||||||||||| Page " +
                this.id +
                " ||||||||||||||||||||||||||||||||||||||||||||||"
        );
        this.h.l("+++ Config +++");
        this.h.l(this.config);

        this._removeAllClasses = function (group = "") {
            var self = this;
            // if (page.config.attributes.button.multiValue == false) {
            // nicht mehr pro attributes selctor sondern wird von der page config gesetzt
            this.config.triggerSelector.forEach((selector) => {
                self.el.find(`${selector}${group == "" ? "" : '[name="' + group + '"]'}`).each(function () {
                    const c = `wizard-${self.config.triggerType}-active`;

                    jQuery(this).removeClass(c);
                    jQuery(`#c-${this.id}`).removeClass(`wizard-navigation-active`);
                });
            });
        };

        this._uncheckAll = function () {
            var self = this;
            this.config.triggerSelector.forEach((selector) => {
                self.el.find(selector).each(function () {
                    jQuery(this).prop("checked", false);
                });
            });
        };

        this._resetAllValuesToOrigin = function () {
            var self = this;
            this.config.triggerSelector.forEach((selector) => {
                self.el.find(selector).each(function () {
                    self.h.l("+ + + + + + + + _resetAllValuesToOrigin + + + + + + + + +");
                    self.h.l(this);
                    self.h.l(jQuery(this).data("origin-value"));
                    self._setValueToTarget(this, jQuery(this).data("origin-value"));
                });
            });
        };

        this._resetAllValuesToZero = function () {
            var self = this;
            this.config.triggerSelector.forEach((selector) => {
                self.el.find(selector).each(function () {
                    self._setValueToTarget(this, 0);
                });
            });
        };

        this._addClassToTargetIfConditionOrToggle = function (target, condition, toggle = false) {
            var _class = `wizard-${this.config.triggerType}-active`,
                tEl = jQuery(target);

            this.h.l("+ + + + _addClassToTargetIfConditionOrToggle + + + +");
            this.h.l(_class);
            this.h.l(condition);
            this.h.l(toggle);
            this.h.l(target);

            if (toggle) {
                tEl.toggleClass(_class);
                jQuery(`#c-${target.id}`).toggleClass(`wizard-navigation-active`);
                return;
            }
            if (condition) {
                if (this.config.triggerType == `radio`) this._removeAllClasses(target.name);
                tEl.addClass(_class);
                jQuery(`#c-${target.id}`).addClass(`wizard-navigation-active`);
            }
            //  else {
            //     tEl.removeClass(_class);
            // }
        };

        this._getDataByAttributes = function (attr) {
            if (attr.length == 0) return {};
            var data = attr["data_condition"]
                ? {
                      key: attr["data_key"],
                      value: attr["data_value"],
                      breadcrumb: attr["data_breadcrumb"],
                      description: attr["data_description"],
                  }
                : {};
            return data;
        };

        this._cbEnd = function (callback, _return) {
            this.h.l(`[UW-Trace]: End Page::${callback} (${this.config.triggerType})`);
            if (_return) return false;
        };

        this._hasTargetCondition = function (target) {
            var tEl = jQuery(target);

            if (this.config.triggerType == `button`) return true;
            // if (this.config.triggerType == `contact-form`) return true;
            if (this.config.triggerType == `textfield`) return target.value != tEl.data("origin-value");
            if (this.config.triggerType == `checkbox`) return tEl.prop("checked");
            if (this.config.triggerType == `select`) return tEl.val() != 0;
            if (this.config.triggerType == `radio`) return target.checked;
            return false;
        };

        this._prevent = function () {
            if (this.config.triggerType == `button`) return true;
            // if (this.config.triggerType == `contact-form`) return true;
            if (this.config.triggerType == `textfield`) return true;
            if (this.config.triggerType == `checkbox`) return false;
            if (this.config.triggerType == `select`) return false;
            if (this.config.triggerType == `radio`) return false;
            return false;
        };

        this._return = function () {
            if (this.config.triggerType == `button`) return true;
            // if (this.config.triggerType == `contact-form`) return true;
            if (this.config.triggerType == `textfield`) return true;
            if (this.config.triggerType == `checkbox`) return false;
            if (this.config.triggerType == `select`) return false;
            if (this.config.triggerType == `radio`) return true;
            return false;
        };

        this._toggle = function () {
            if (this.config.triggerType == `button`) return true;
            // if (this.config.triggerType == `contact-form`) return false;
            if (this.config.triggerType == `textfield`) return false;
            if (this.config.triggerType == `checkbox`) return true;
            if (this.config.triggerType == `select`) return false;
            if (this.config.triggerType == `radio`) return false;
            return false;
        };

        this._getDataFromTarget = function (target, is_condition = true) {
            var _class = `wizard-${this.config.triggerType}-active`,
                tEl = jQuery(target);

            this.h.l("##### TEXT #####");
            this.h.l(tEl.text());

            if (this.config.triggerType == `button`)
                return {
                    data_key: target.id,
                    data_value: tEl.attr(this.config.triggerAttribute),
                    // data_breadcrumb: tEl.text(),
                    data_breadcrumb: this.config.breadcrumb,
                    data_description: this.config.description,
                    data_condition: is_condition ? tEl.hasClass(_class) : true,
                };
            if (this.config.triggerType == `textfield`)
                return {
                    data_key: target.id,
                    data_value: target.value,
                    // data_breadcrumb: tEl.text(),
                    data_breadcrumb: this.config.breadcrumb,
                    data_description: this.config.description,
                    data_condition: is_condition ? tEl.hasClass(_class) : true,
                };
            if (this.config.triggerType == `checkbox`)
                return {
                    data_key: target.id,
                    data_value: tEl.attr(this.config.triggerAttribute),
                    // data_breadcrumb: tEl.text(),
                    data_breadcrumb: this.config.breadcrumb,
                    data_description: this.config.description,
                    data_condition: is_condition ? tEl.hasClass(_class) : true,
                };
            if (this.config.triggerType == `select`)
                return {
                    data_key: target.id,
                    data_value: tEl.val(),
                    // data_breadcrumb: tEl.text(),
                    data_breadcrumb: this.config.breadcrumb,
                    data_description: this.config.description,
                    data_condition: is_condition ? tEl.val() != 0 : true,
                };
            if (this.config.triggerType == `radio`)
                return {
                    data_key: target.id,
                    data_value: tEl.attr(this.config.triggerAttribute),
                    // data_breadcrumb: tEl.text(),
                    data_breadcrumb: this.config.breadcrumb,
                    data_description: this.config.description,
                    data_condition: is_condition ? tEl.hasClass(_class) : true,
                };
            return {};
        };

        this._getWeightFromTarget = function (target) {
            var tEl = jQuery(target);

            if (this.config.triggerType == `button`) return tEl.data("weight");
            if (this.config.triggerType == `checkbox`) return tEl.data("weight");
            if (this.config.triggerType == `radio`) return tEl.data("weight");
            return 0;
        };

        this._getTaxonomyStringFromTarget = function (target) {
            var tEl = jQuery(target);

            return tEl.data("taxonomy");
        };

        this._setValueToTarget = function (target, value) {
            var tEl = jQuery(target);

            if (this.config.triggerType == `button`) tEl.attr(this.config.triggerAttribute, value);
            // tEl.attr(this.config.triggerAttribute, value);
            if (this.config.triggerType == `textfield`) target.value = value;
            if (this.config.triggerType == `checkbox`) tEl.attr(this.config.triggerAttribute, value);
            // tEl.find(`option[${this.config.triggerAttribute}="${value}"]`).attr('selected', 'selected');
            if (this.config.triggerType == `select`) target.value = value;
            if (this.config.triggerType == `radio`) tEl.attr(this.config.triggerAttribute, value);
        };

        this._checkTarget = function (target) {
            var tEl = jQuery(target);

            if (this.config.triggerType == `button`) return;
            if (this.config.triggerType == `textfield`) return;
            if (this.config.triggerType == `checkbox`) tEl.prop("checked", true);
            if (this.config.triggerType == `select`) return;
            if (this.config.triggerType == `radio`) tEl.prop("checked", true);
        };

        this._resetAllBeforeSet = function (target) {
            if (this.config.triggerType == `button`) {
                return;
            }
            if (this.config.triggerType == `textfield`) {
                var tmpValue = target.value;
                this._resetAllValuesToOrigin();
                this._setValueToTarget(target, tmpValue);
                return;
            }
            if (this.config.triggerType == `checkbox`) {
                this._uncheckAll();
                this._checkTarget(target);
                return;
            }
            if (this.config.triggerType == `select`) {
                tmpValue = target.value;
                this._resetAllValuesToZero();
                this._setValueToTarget(target, tmpValue);
                return;
            }
            if (this.config.triggerType == `radio`) {
                this._uncheckAll();
                this._checkTarget(target);
                return;
            }
        };

        this._getFuncName = function () {
            return "caller function is deprecated";
            // return this._getFuncName.caller.name;
        };

        this._logGet = function (func) {
            this.h.l(`[UW-Trace]: Start Page::${func} (${this.config.triggerType})`);
            this.h.l(this._tmpValue);
            this.h.l(this._tmpWeight);
            this.h.l(this._tmpTaxonomyString);
            this.h.l(this._tmpDescription);
            this.h.l(`[UW-Trace]: End Page::${func} (${this.config.triggerType})`);
        };

        this._logStart = function (func) {
            this.h.l(`[UW-Trace]: Start Page::${func} (${this.config.triggerType})`);
        };

        this._logEnd = function (func) {
            this.h.l(`[UW-Trace]: End Page::${func} (${this.config.triggerType})`);
        };

        this._pushValueToTmp = function (data) {
            this.h.l("+ + + + Push Data + + + +");
            this.h.l(data);
            this.config.wizard.displayNavigationContainerElement("skip", data.length === 0);
            this.config.wizard.disableNavigationElement("next", data.length === 0);
            this._tmpValue = JSON.stringify(data);
        };

        this._pushWeightToTmp = function (weight) {
            this.h.l("+ + + + Push Weight + + + +");
            this.h.l(weight);
            this._tmpWeight = weight;
        };

        this._pushTaxonomyStringToTmp = function (string) {
            this.h.l("+ + + + Push Taxonomy String + + + +");
            this.h.l(string);
            this._tmpTaxonomyString = string;
        };

        this._pushDescriptionToTmp = function (description) {
            this.h.l("+ + + + Push Description + + + +");
            this.h.l(description);
            this._tmpDescription = description;
        };

        this._conditionByTargetAndValue = function (target, value) {
            var tEl = jQuery(target);

            if (this.config.triggerType == `button`) return tEl.attr(this.config.triggerAttribute) == value;
            if (this.config.triggerType == `textfield`) return target.value == value;
            if (this.config.triggerType == `checkbox`) return tEl.attr(this.config.triggerAttribute) == value;
            if (this.config.triggerType == `select`) return tEl.val() == value;
            if (this.config.triggerType == `radio`) return tEl.attr(this.config.triggerAttribute) == value;
            return false;
        };
    };

    // #strict
    uva.wizard.Page.prototype._cbClick = function (element) {
        var data = [],
            weight = 0,
            taxonomy = "",
            self = this,
            target = element.currentTarget;

        var prevent = this._prevent(),
            _return = this._return(),
            toggle = this._toggle(),
            condition = this._hasTargetCondition(target);

        this.h.l(`[UW-Trace]: Start Page::${this._getFuncName()}`);
        this.h.trigger(`${this.config.triggerType}-${this.id}`, this.config.wizard);

        if (prevent) {
            element.preventDefault();
        }

        if (this.config.multiValue == false) {
            this._removeAllClasses();
        }

        this._addClassToTargetIfConditionOrToggle(target, condition, toggle);

        if (this.config.multiValue == false) {
            this._resetAllBeforeSet(target);
            const d = this._getDataByAttributes(this._getDataFromTarget(target));
            data.push(d);
            weight = this._getWeightFromTarget(target);
            taxonomy = this._getTaxonomyStringFromTarget(target);
        } else {
            this.config.triggerSelector.forEach((selector) =>
                self.el.find(`${selector}.wizard-${this.config.triggerType}-active`).each(function () {
                    const d = self._getDataByAttributes(self._getDataFromTarget(this, false));
                    data.push(d);
                    weight = weight + self._getWeightFromTarget(this);
                    taxonomy = self._getTaxonomyStringFromTarget(this);
                })
            );
        }
        this._pushValueToTmp(data);
        this._pushWeightToTmp(weight);
        this._pushTaxonomyStringToTmp(taxonomy);
        this._pushDescriptionToTmp(this.config.description);

        var f = this.config.forwardOnClick,
            tEl = jQuery(target);

        if (tEl.data("custom-forward")) f = tEl.data("forward-on-click");
        if (f) this.config.router.routeForward();

        this._cbEnd(this._getFuncName(), _return);
    };

    // #strict
    uva.wizard.Page.prototype._cbTextKeyup = function (e) {
        var etEl = jQuery(e.target);

        if (e.key !== "Enter") return true;
        if (etEl.prop("tagName") == "INPUT" && etEl.prop("type") == "text") {
            e.preventDefault();
            return false;
        }
        return true;
    };

    // #strict
    uva.wizard.Page.prototype._cbLoad = function () {
        var self = this;

        //-- load all _cbClick to event types
        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                event.on.forEach((o) => {
                    self.config.triggerSelector.forEach((e) => self.el.on(o, e, jQuery.proxy(self._cbClick, self)));
                    self.h.on(`${self.config.triggerType}-${self.id}`, self.config.wizard);
                });
            }
        });

        //-- textfield event to prevent enter --
        if (this.config.triggerType === `textfield`) {
            this.config.triggerSelector.forEach((e) => self.el.on(`keydown`, e, jQuery.proxy(self._cbTextKeyup, self)));
        }
    };

    // #strict
    uva.wizard.Page.prototype._makeOriginalCheckboxes = function (s) {
        var labels = [],
            self = this;

        this.h.l("############### make original ###############");
        this.h.l(s);

        // jQuery(s)
        s.find(`input[type="checkbox"]`).each(function () {
            self.h.l(this);
            labels.push(this.id);
            if (this.id) this.id = "c-" + this.id;
        });
        // jQuery(s)
        labels.forEach(function (l) {
            self.h.l(l);
            s.find(`label[for="${l}"]`).each(function () {
                self.h.l(this);
                self.h.l(jQuery(this).attr("for"));
                if (jQuery(this).attr("for")) jQuery(this).attr("for", "c-" + jQuery(this).attr("for"));
            });
        });
    };
    //
    //
    //
    //
    //
    // #strict
    uva.wizard.Page.prototype._loadFromLocal = function (showAfterLoading) {
        this.h.l(`[UW-Trace]: Start Page::_loadFromLocal - ${this.config.contentSelector}`);
        this.h.l(`############# CLONE ############# - ${this.config.contentSelector}`);
        this.el = jQuery(this.config.contentSelector).clone();
        this.config.wizard.el.trigger("uw:beforelocalload", [this]);

        // this._makeOriginalCheckboxes(this.config.contentSelector);
        this._makeOriginalCheckboxes(this.el);

        this.el.addClass("wizard-page");
        // this.el.addClass("page-type-" + this.config.triggerType);
        this.el.attr("id", "wizard-page-" + this.config.id);
        this.el.css("display", ""); //Remove possible display: none

        if (this.config.allowClasses === false) {
            this.el.find("*").removeClass(this.config.wizard.config.disallowedClasses);
        }

        this.config.wizard.el.prepend(this.el);

        this.loaded = true;

        this._cbLoad();

        this.config.wizard.el.trigger("uw:afterlocalload", [this]);
        if (showAfterLoading) {
            this.show();
        }
        this.h.l(`[UW-Trace]: End Page::_loadFromLocal - ${this.config.contentSelector}`);
    };
    //
    //
    //
    //
    //
    // #strict
    uva.wizard.Page.prototype._getDescription = function () {
        this._logGet("_getDescription");
        return this._tmpDescription;
    };

    // #strict
    uva.wizard.Page.prototype._getWeight = function () {
        this._logGet("_getWeight");
        return this._tmpWeight;
    };

    // #strict
    uva.wizard.Page.prototype._getTaxonomyString = function () {
        this._logGet("_getTaxonomyString");
        return this._tmpTaxonomyString;
    };

    // #strict
    uva.wizard.Page.prototype._getValue = function () {
        this._logGet("_getValue");
        return this._tmpValue;
    };

    // #strict
    uva.wizard.Page.prototype._setValue = function (trigger) {
        this._logStart("_setValue");
        var data = [],
            weight = 0,
            taxonomy = "",
            self = this,
            target = [];

        if (this.config.multiValue == false) {
            this._removeAllClasses();
        }

        this.config.triggerSelector.every((selector) => {
            trigger = Array.isArray(trigger) ? trigger : [trigger];
            trigger.every((t) => {
                self.el.find(`${selector}#${t.key}`).each(function () {
                    const d = {
                        element: this,
                        trigger: t,
                    };

                    target.push(d);
                    self._addClassToTargetIfConditionOrToggle(this, true, false);
                    return self.config.multiValue == false && target.length != 0 ? false : true;
                });
                return self.config.multiValue == false && target.length != 0 ? false : true;
            });
            return self.config.multiValue == false && target.length != 0 ? false : true;
        });
        this.h.l("+ + + + TARGETS + + + +");
        if (target.length == 0) return;
        this.h.l(target);

        target.every((t) => {
            self._setValueToTarget(t.element, t.trigger.value);
            self._checkTarget(t.element);
            const d = self._getDataByAttributes(self._getDataFromTarget(t.element, null, false));
            data.push(d);
            weight = weight + self._getWeightFromTarget(t.element);
            taxonomy = self._getTaxonomyStringFromTarget(t.element);
            return this.config.multiValue == false ? false : true;
        });

        this._pushValueToTmp(data);
        this._pushWeightToTmp(weight);
        this._pushTaxonomyStringToTmp(taxonomy);
        this._pushDescriptionToTmp(this.config.description);
        this._logEnd("_setValue");
    };

    // #strict
    uva.wizard.Page.prototype.getValue = function () {
        var self = this,
            _match = null;

        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                _match = self._getValue();
            }
        });
        return _match;
    };

    // #strict
    uva.wizard.Page.prototype.setValue = function (trigger) {
        var self = this,
            _match = null;

        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                self._setValue(trigger);
            }
        });
    };

    // #strict
    uva.wizard.Page.prototype.getDescription = function () {
        var self = this,
            _match = null;

        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                _match = self._getDescription();
            }
        });
        return _match;
    };

    // #strict
    uva.wizard.Page.prototype.getWeight = function () {
        var self = this,
            _match = null;

        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                _match = self._getWeight();
            }
        });
        return _match;
    };

    // #strict
    uva.wizard.Page.prototype.getTaxonomyString = function () {
        var self = this,
            _match = null;

        this.events.forEach((event) => {
            if (self.config.triggerType === event.type) {
                _match = self._getTaxonomyString();
            }
        });
        return _match;
    };

    // #strict
    uva.wizard.Page.prototype.hide = function (direction = "out-left") {
        this.h.l("[UW-Trace]: Start Page::hide");
        this.el.removeClass("page-active");
        this.el.removeClass("page-active-left");
        this.el.removeClass("page-active-right");
        direction == "out-left" && this.el.addClass("page-out-left");
        direction == "out-right" && this.el.addClass("page-out-right");

        this.h.l("[UW-Trace]: End Page::hide");
    };

    // #strict
    uva.wizard.Page.prototype.isLoaded = function () {
        return this.loaded;
    };

    // #strict
    uva.wizard.Page.prototype.load = function (showAfterLoading) {
        this.h.l("[UW-Trace]: Start Page::load");
        var callback = this.show,
            self = this,
            stage = parseInt(this.config.stage, 10),
            stageMax = parseInt(this.config.stageMax, 10),
            sa = showAfterLoading,
            url = this.config.src,
            list = "",
            li = "",
            customEl = jQuery(
                `<div id="navigation-container-custom-${this.id}" class="${this.config.navigation.containerCustomCss}"></div>`
            ),
            toNavEl = jQuery("#" + self.config.wizardId + " #" + self.config.pageId)
                .find("*")
                .filter(function () {
                    jQuery(this).show();
                    return jQuery(this).data("to-navigation");
                }),
            cloneNavEl = toNavEl.clone(true),
            customIndicatorsEl = jQuery(`<div id="wizard-indicators-custom-${this.id}"></div>`),
            olEl;

        this.h.l(`############# CLONE ############# - Object`);
        this.h.l(toNavEl);
        this.h.l(`#############`);

        function clone_id(e) {
            var id = jQuery(e).attr("id");

            jQuery(e).attr("id", `c-${id}`);
            jQuery(e).on("click", function (e) {
                var originalEl = jQuery(`.wizard-page #${id}`);
                originalEl.trigger("click");
            });
        }

        cloneNavEl.each(function () {
            clone_id(this);

            jQuery(this)
                .children()
                .each(function () {
                    clone_id(this);
                });
        });

        toNavEl.hide();

        this.h.l("#" + self.config.wizardId + " #" + self.config.pageId);
        this.h.l(toNavEl);

        this.config.wizard.el.find("#wizard-navigation").append(customEl.append(cloneNavEl));
        this.config.navigation.isnavigation && this.config.wizard.el.find(`#wizard-navigation`).attr("style", "");
        !this.config.navigation.isnavigation &&
            this.config.wizard.el.find(`#wizard-navigation`).attr("style", "display: none !important");

        // Indicators start
        if (this.config.wizard.config.indicatorsVisible) {
            this.h.l("####### Indicators ######");

            if (stage >= 0 && stageMax > 0) {
                this.h.l(stage);
                li = `<li class="done wizard-indicator ${this.config.wizard.config.indicatorCss}">`;
                for (let i = 1; i < stage; i++) {
                    list = list + li;
                }

                stage > 0 && (li = `<li class="active wizard-indicator ${this.config.wizard.config.indicatorCss}">`);
                stage > 0 && (list = list + li);

                li = `<li class="wizard-indicator ${this.config.wizard.config.indicatorCss}">`;
                for (let i = stage + 1; i <= stageMax; i++) {
                    list = list + li;
                }
                this.h.l(list);
            }

            olEl = jQuery(`<ol>${list}</ol>`);
            this.config.wizard.config.renderTo.find("#wizard-indicators").append(customIndicatorsEl.append(olEl));
        }
        // Indicators end

        if (this.config.src == "local") return this._loadFromLocal(showAfterLoading);

        if (url.indexOf("?") >= 0) {
            url += "&uva_wizard_history=" + JSON.stringify(this.config.router.history);
        } else {
            url += "?uva_wizard_history=" + JSON.stringify(this.config.router.history);
        }

        this.h.l("[UW-Trace]: - Load page '" + this.id + "'");
        this.config.wizard.el.trigger("uw:beforeajaxload", [this]);
        this.config.wizard.setLoading(true);
        jQuery.ajax({
            type: this.config.method,
            url: url,
            success: function (content) {
                var contentEl = jQuery(`<div><div class="wiz-tmp">${content}</div></div>`),
                    contentSelector = ".wiz-tmp",
                    saClass = sa ? " page-next " : "",
                    selector = "#" + self.config.wizardId + " #" + self.config.pageId;

                if (!self.isLoaded()) {
                    if (self.config.contentSelector && self.config.contentSelector != "") {
                        contentSelector = self.config.contentSelector;
                    }

                    self.loaded = true;
                    self.h.l("+++ form +++");
                    self.h.l(content);
                    self.h.l(contentEl);
                    self.h.l(contentSelector);
                    self.h.l(contentEl.find(contentSelector));
                    self.el = jQuery(
                        // `<div id="wizard-page-${self.config.id}" class="wizard-page page-type-${self.config.triggerType} ${saClass}">
                        `<div id="wizard-page-${self.config.id}" class="wizard-page ${self.config.pageCss} ${saClass}">` +
                            `<div class="${self.config.contentCss}">` +
                            `${contentEl
                                .find(contentSelector)
                                .html()
                                .replace(/<form[^>]+>|<\/form>/gi, "")
                                .replace(/<button/gi, "<input")
                                .replace(/type="submit"/gi, "")
                                .replace(/role="[^"]+"/gi, "")
                                .replace(/class="[^"]+"/gi, "")}` +
                            `</div>` +
                            `</div>`
                    );
                    // entferne die form-tags vom formular
                    // wandle das button tag in ein input tag um, weil der name und das value auch relevante daten enthalten können, da es das eigentlich submit ist
                    // lösche type=""
                    // lösche role=""
                    // lösche class=""
                    // lösche value="1", da checkboxen als standard-value "1" haben
                    var divEl = jQuery(
                        `<div style="display: none">` +
                            `${contentEl
                                .find(contentSelector)
                                .html()
                                .replace(/<form[^>]+>|<\/form>/gi, "")
                                .replace(/<button/gi, "<input")
                                .replace(/type="submit"/gi, "")
                                .replace(/role="[^"]+"/gi, "")
                                .replace(/class="[^"]+"/gi, "")}` +
                            `</div>`
                    );
                    self.el = jQuery(selector).clone().prepend(divEl);

                    // self._makeOriginalCheckboxes(selector);
                    self._makeOriginalCheckboxes(self.el);

                    if (self.config.allowClasses === false) {
                        self.el.find("*").removeClass(self.config.wizard.config.disallowedClasses);
                    }
                    self.el.find("script").html("");

                    self.el.addClass("wizard-page");
                    self.el.attr("id", "wizard-page-" + self.config.id);
                    self.el.css("display", ""); //Remove possible display: none

                    self.config.wizard.el.prepend(self.el);

                    self._cbLoad();

                    self.h.l("uw:afterajaxload");
                    self.config.wizard.el.trigger("uw:afterajaxload", [self]);
                    if (sa) {
                        callback.call(self, content);
                    }
                    self.config.wizard.setLoading(false);
                    self.loadValidation();
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                // TODO: 404 error handling
                // self.config.wizard.setLoading(true);
                self.h.l(textStatus);
                self.h.l(responseData);
                self.h.l(errorThrown);
            },
        });

        this.h.l("[UW-Trace]: End Page::load");
    };

    // #strict
    uva.wizard.Page.prototype.loadValidation = function () {
        var self = this,
            input = null,
            label = null;

        jQuery.validator.setDefaults({
            debug: true,
            success: "valid",
            submitHandler: function () {
                // alert("submit");
                self.config.wizard.router.routeForward();
                return false;
            },
        });

        jQuery.validator.addMethod(
            "phoneDE",
            function (phone_number, element) {
                var regex = /[+]{0,1}[(]{0,1}[0-9]{1,6}[)]{0,1}[-\s\./0-9]*/g,
                    valid = false;

                // clear all spaces before match
                phone_number = phone_number.replace(/[\s]+/g, "");

                valid = phone_number.match(regex) == phone_number;

                self.h.l(phone_number);
                self.h.l(phone_number.match(regex));
                phone_number = phone_number.replace(/[()-\s./+]+/g, "");
                self.h.l(phone_number);

                return this.optional(element) || (phone_number.length >= 9 && phone_number.length <= 20 && valid);
            },
            "Bitte geben Sie eine gültige Telefonnummer an."
        );

        jQuery.extend(jQuery.validator.messages, {
            required: "",
            remote: "Please fix this field.",
            email: "",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            equalTo: "Please enter the same value again.",
            accept: "Please enter a value with a valid extension.",
            maxlength: jQuery.validator.format("Please enter no more than {0} characters."),
            minlength: jQuery.validator.format("Please enter at least {0} characters."),
            rangelength: jQuery.validator.format("Please enter a value between {0} and {1} characters long."),
            range: jQuery.validator.format("Please enter a value between {0} and {1}."),
            max: jQuery.validator.format("Please enter a value less than or equal to {0}."),
            min: jQuery.validator.format("Please enter a value greater than or equal to {0}."),
        });

        this.h.l("validate");
        this.h.l(this.el);
        this.h.l(this.config.rules);

        "rules" in this.config &&
            this.config.wizard.el.validate({
                rules: this.config.rules,
                errorClass: "error",
                validClass: "valid",
                success: "",
                // focusCleanup: true,
                focusInvalid: false,
                highlight: function (element, errorClass, validClass) {
                    jQuery(element).addClass("wizard-error").removeClass(validClass);
                    jQuery(element.form)
                        .find("label[for=" + element.id + "]")
                        .addClass("wizard-error");
                },
                unhighlight: function (element, errorClass, validClass) {
                    jQuery(element).removeClass("wizard-error").addClass(validClass);
                    jQuery(element.form)
                        .find("label[for=" + element.id + "]")
                        .removeClass("wizard-error");
                },
            });
    };

    // #strict
    uva.wizard.Page.prototype.setNext = function () {
        this.config.wizard.el.find(".wizard-page").removeClass("page-next");
        if (this.el) this.el.addClass("page-next");
    };

    // #strict
    uva.wizard.Page.prototype.setPrevious = function () {
        this.config.wizard.el.find(".wizard-page").removeClass("page-previous");
        if (this.el) this.el.addClass("page-previous");
    };

    // #strict
    uva.wizard.Page.prototype.show = function (direction = "left") {
        this.h.l("[UW-Trace]: Start Page::show");
        if (!this.isLoaded()) {
            this.load(true);
            return;
        }

        this.h.l("[UW-Trace]: - Show page " + this.id);
        this.el.removeClass("page-out-left");
        this.el.removeClass("page-out-right");

        this.el.addClass("page-active");
        direction == "left" && this.el.addClass("page-active-left");
        direction == "right" && this.el.addClass("page-active-right");

        this.config.navigation.isnavigation && this.config.wizard.el.find(`#wizard-navigation`).attr("style", "");
        !this.config.navigation.isnavigation &&
            this.config.wizard.el.find(`#wizard-navigation`).attr("style", "display: none !important");

        this.config.wizard.el.find(`div[id^="navigation-container-custom-"]`).hide();

        con && console.log(`+++ #navigation-container-custom-${this.id} +++`);
        this.config.wizard.el.find(`#navigation-container-custom-${this.id}`).each(function (e) {
            jQuery(this).children().length > 0 && jQuery(this).show();
        });
        // this.config.wizard.el.find(`#navigation-container-custom-${this.id}`).show();

        this.config.wizard.config.renderTo.find(`div[id^="wizard-indicators-custom-"]`).hide();
        this.config.wizard.config.renderTo.find(`#wizard-indicators-custom-${this.id}`).show();
        this.el.removeClass("page-previous");
        this.el.removeClass("page-next");

        this.h.l("[UW-Trace]: End Page::show");
    };

    // Wizard
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    // #strict
    uva.Wizard = function (cfg) {
        var n = {};

        this.h = new uva.Helper({});
        this.version = "2.0.0";

        this.displaynavigationarray = [
            ["previous", "hidePreviousButton"],
            ["next", "hideNextButton"],
            ["skip", "hideSkipButton"],
            ["reset", "hideResetButton"],
            ["submit", "hideSubmitButton"],
            ["navigation-text", "hideNavigationText"],
        ];

        this.defaultnavigationarray = {
            previous: [
                `wizard-previous ${BOOTSTRAP ? "d-flex flex-nowrap text-nowrap btn btn-default" : ""}`,
                "wizard-container-previous",
            ],
            next: [
                `wizard-next ${BOOTSTRAP ? "d-flex flex-nowrap text-nowrap btn btn-primary" : ""}`,
                "wizard-container-next",
            ],
            skip: [
                `wizard-skip ${BOOTSTRAP ? "d-flex flex-nowrap text-nowrap btn btn-default" : ""}`,
                "wizard-container-skip",
            ],
            reset: [
                `wizard-reset ${BOOTSTRAP ? "d-flex flex-nowrap text-nowrap btn btn-default" : ""}`,
                "wizard-container-reset",
            ],
            submit: [
                `wizard-submit ${BOOTSTRAP ? "d-flex flex-nowrap text-nowrap btn btn-primary" : ""}`,
                "wizard-container-submit",
            ],
            "navigation-text": [`wizard-navigation-text`, "wizard-container-navigation-text"],
        };

        // order important for navigation rendering
        // id-suffix, element-html, element-css, container-css, is custom?, tag, tag type
        this.navigationarray = [
            {
                suffix: "navigation-text",
                html: ["navigationText", ""],
                css: ["navigationTextCss", ""],
                containercss: ["containerNavigationTextCss", ""],
                iscustom: "customNavigationText",
                tag: "p",
                type: "",
            },
            {
                suffix: "previous",
                html: ["previousButton", "<<"],
                css: ["previousCss", ""],
                containercss: ["containerPreviousCss", ""],
                iscustom: "customPreviousButton",
                tag: "button",
                type: "button",
            },
            {
                suffix: "skip",
                html: ["skipButton", "Skip"],
                css: ["skipCss", ""],
                containercss: ["containerSkipCss", ""],
                iscustom: "customSkipButton",
                tag: "button",
                type: "button",
            },
            {
                suffix: "reset",
                html: ["resetButton", "Reset"],
                css: ["resetCss", ""],
                containercss: ["containerResetCss", ""],
                iscustom: "customResetButton",
                tag: "button",
                type: "button",
            },
            {
                suffix: "submit",
                html: ["submitButton", "Submit"],
                css: ["submitCss", ""],
                containercss: ["containerSubmitCss", ""],
                iscustom: "customSubmitButton",
                tag: "button",
                type: "submit",
            },
            {
                suffix: "next",
                html: ["nextButton", ">>"],
                css: ["nextCss", ""],
                containercss: ["containerNextCss", ""],
                iscustom: "customNextButton",
                tag: "button",
                type: "button",
            },
        ];

        this.navigationarray.forEach(function (a) {
            n[a.html[0]] = a.html[1];
            n[a.css[0]] = a.css[1];
            n[a.containercss[0]] = a.containercss[1];
        });
        n.containerCustomCss = "";

        n.navigationCss = "";
        n.formCss = "";
        n.isnavigation = true;

        this.configOrigin = jQuery.extend(
            {
                renderTo: null,
                items: [],
                header: [],
                router: [],
                startPageId: 0,
                preloadPages: false,
                wizardCss: "",
                disallowedClasses: [],
                on: {},
                autoroute: [],
                dispatcher: [],
                navigation: n,
                indicatorsVisible: true,
                indicatorsCss: "",
                indicatorCss: "",
                breadcrumbsVisible: false,
                breadcrumbsCss: "",
                breadcrumbCss: "",

                scrollTop: false,
                scrollOffset: "0",
                scrollToAnchor: false,
                scrollSpeed: "smooth",
            },
            cfg
        );

        this.h.l(
            "|||||||||||||||||||||||||||||||||||||||| Start UVA Wizard - Version " +
                this.version +
                "|||||||||||||||||||||||||||||||||||||||||"
        );
        this.config = { ...this.configOrigin };
        this.h.l("+++ Config +++");
        this.h.l(this.config);
        this.renderNavigation();
        this.init();
    };

    // #strict
    uva.Wizard.prototype._setNavigation = function (wizard) {
        var page = wizard._getCurrentPage(),
            self = this,
            nextEntries;

        this.displaynavigationarray.forEach(function (a) {
            var h = page.el.find(
                `.wizard-button-active, .wizard-textfield-active, .wizard-checkbox-active, .wizard-select-active, .wizard-radio-active`
            ).length;
            self.displayNavigationContainerElement(
                a[0],
                h && a[0] == "skip" ? h == 0 && !page.config[a[1]] : !page.config[a[1]]
            );
            nextEntries = wizard._getNextEntries(page);
            if (nextEntries.length < 1 && !page.config.multiValue) {
                self.displayNavigationContainerElement("next", false);
            }
            page.config.multiValue && h == 0 && self.disableNavigationElement("next", true);
        });

        // this.displayNavigationContainerElement("previous", !this.router.isFirstPage() && !page.config.hidePreviousButton);
        // this.displayNavigationContainerElement("next", !page.config.hideNextButton);
        // this.displayNavigationContainerElement("skip", !page.config.hideSkipButton);
        // this.displayNavigationContainerElement("reset", !page.config.hideResetButton);
        // this.displayNavigationContainerElement("submit", !page.config.hideSubmitButton);
        // this.displayNavigationContainerElement("navigation-text", !page.config.hideNavigationText);

        this.styleNavigation(page);
    };

    // #strict
    uva.Wizard.prototype._setBreadcrumbs = function (wizard, append) {
        var page = wizard._getCurrentPage(),
            breadcrumb = page.config.breadcrumb,
            classname = `wizard-breadcrumb-item breadcrumb-item`,
            self = this;

        // Breadcrumbs start
        this.h.l("####### Breadcrumbs ######");
        this.h.l(breadcrumb);

        if (page.config.wizard.config.breadcrumbsVisible) {
            if (append) {
                if (page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").length > 0) {
                    classname = classname + ` link`;
                }
                page.config.wizard.config.renderTo
                    .find("#wizard-breadcrumb")
                    .append(`<li class="${classname} ${page.config.wizard.config.breadcrumbCss}">${breadcrumb}</li>`);
                page.config.wizard.config.renderTo
                    .find("#wizard-breadcrumb li")
                    .last()
                    .on("click", jQuery.proxy(this.breadcrumbpreviousPage, this));

                // if appended item is hidden
                page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").last().show();
                if (breadcrumb == "") {
                    page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").last().hide();
                }
            } else {
                page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").last().remove();
            }
        }
        // Breadcrumbs end
    };

    // #strict
    uva.Wizard.prototype._cbAfterRouteForward = function (e, wizard, breadcrumb) {
        // var page = wizard._getCurrentPage();

        this.h.l("_cbAfterRouteForward");
        this._setNavigation(wizard);
        con && console.log("next");
        con && console.log(breadcrumb);
        breadcrumb && this._setBreadcrumbs(wizard, true);

        // page.setValue(e.trigger)
    };

    // #strict
    uva.Wizard.prototype._cbAfterRouteBackward = function (e, wizard, breadcrumb) {
        this.h.l("_cbAfterRouteBackward");
        this._setNavigation(wizard);
        con && console.log("back");
        con && console.log(breadcrumb);
        breadcrumb && this._setBreadcrumbs(wizard, false);
    };

    // #strict
    uva.Wizard.prototype._getCurrentPage = function () {
        return this.router.getCurrentPage();
    };

    // #strict
    uva.Wizard.prototype._getNextEntries = function (page) {
        return this.router.getNextEntries(page);
    };

    // #strict
    uva.Wizard.prototype._getFirstPage = function () {
        return this.getPage(this.config.startPageId);
    };

    // #strict
    uva.Wizard.prototype.styleNavigation = function (page) {
        var self = this,
            d = this.defaultnavigationarray;

        this.h.l("+++++++++++++ Navigation +++++++++++++");
        this.h.l(this.navigationarray);
        this.navigationarray.forEach(function (a) {
            var el = page.config.customNavigation && page.config[`${a.iscustom}`] ? page : self;
            var n = el.config.navigation;

            self.h.l("+++++++++++++ Navigation Element +++++++++++++");
            self.h.l(n);
            self.h.l(a);
            self.h.l(d);
            self.h.l(page.config);

            self.navEl
                .find(`#wizard-${a.suffix}`)
                .html(n[`${a.html[0]}`])
                .attr("class", `${d[`${a.suffix}`][0]} ${n[`${a.css[0]}`]}`);

            self.navEl
                .find(`#navigation-container-${a.suffix}`)
                .attr("class", `${d[`${a.suffix}`][1]} ${n[`${a.containercss[0]}`]}`);
        });
    };

    // #strict
    uva.Wizard.prototype.disableNavigationElement = function (el, disabled) {
        this.navEl.find(`#wizard-${el}`).prop("disabled", disabled);
        this.h.l(`Disable ${el}`);
    };

    // #strict
    uva.Wizard.prototype.displayNavigationContainerElement = function (el, show) {
        !show && (this.h.l(`Hide ${el}`), this.navEl.find(`#navigation-container-${el}`).hide());
        show && (this.h.l(`Show ${el}`), this.navEl.find(`#navigation-container-${el}`).show());
    };

    // #strict
    uva.Wizard.prototype.disableNavigationContainerElement = function (el, disable) {
        this.h.l(`Disable ${el} ${disable}`), this.navEl.find(`#navigation-container-${el}`).prop("disabled", disable);
    };

    // #strict
    uva.Wizard.prototype.renderNavigation = function () {
        var n = this.config.navigation,
            nav = "",
            ind = "",
            d = this.defaultnavigationarray;

        this.h.l(n);
        this.navigationarray.forEach(function (a) {
            nav =
                nav +
                `<div id="navigation-container-${a.suffix}" class="${d[`${a.suffix}`][1]} ${
                    n[`${a.containercss[0]}`]
                }">` +
                `<${a.tag} id="wizard-${a.suffix}" class="${d[`${a.suffix}`][0]} ${n[`${a.css[0]}`]}" type="${
                    a.type
                }">${n[`${a.html[0]}`]}</${a.tag}>` +
                `</div>`;
        });

        //-- Target element --
        this.el = jQuery(`<form id="wizard-form" class="wizard-form ${n.formCss}"></form>`);

        this.el.trigger("uw:initwizard", [this]);

        this.h.l(`########## HEADER ###########`);
        this.h.l(this.config.header);
        // this.headerEl = this.config.header;
        this.navEl = jQuery(
            `<div id="wizard-navigation" class="wizard-navigation ${n.navigationCss}">` + nav + `</div>`
        );

        this.navEl.find("#wizard-next").on("click", jQuery.proxy(this.nextPage, this));
        this.navEl.find("#wizard-skip").on("click", jQuery.proxy(this.skipPage, this));
        this.navEl.find("#wizard-previous").on("click", jQuery.proxy(this.previousPage, this));
        this.navEl.find("#wizard-reset").on("click", jQuery.proxy(this.reset, this));

        if (this.config.indicatorsVisible) {
            this.indicatorsEl = jQuery(
                `<div id="wizard-indicators" class="wizard-indicators ${this.config.indicatorsCss}">` + ind + `</div>`
            );
        }

        if (this.config.breadcrumbsVisible) {
            this.breadcrumbsEl = jQuery(
                `<nav aria-label="breadcrumb"><ol id="wizard-breadcrumb" class="wizard-breadcrumb ${this.config.breadcrumbsCss} breadcrumb"></ol></nav>`
            );
        }

        this.h.l(`############# FORM ################### ${this.config.renderTo}`);
        this.h.l(this.config.renderTo);
        this.h.l(`#############`);
        // jQuery(this.config.renderTo).html("").append(this.el.append(this.navEl)).append(this.indicatorsEl);
        // jQuery(this.config.renderTo).prepend(this.breadcrumbsEl).prepend(this.headerEl);
        jQuery(this.config.renderTo).html("").append(this.el.append(this.navEl)).append(this.indicatorsEl);
        jQuery(this.config.renderTo).prepend(this.breadcrumbsEl);
    };

    // #strict
    uva.Wizard.prototype.init = function () {
        var self = this;

        this.renderNavigation();

        //-- Init router --
        this.router = new uva.wizard.Router(
            jQuery.extend({
                routing: this.config.router,
                wizard: this,
            })
        );

        //-- Init page / finisher objects --
        this.pages = {};
        this.finishers = {};
        this.config.items.forEach((e) => {
            if (!e.type || e.type === "page") {
                let po = new uva.wizard.Page(
                    jQuery.extend(
                        {
                            router: this.router,
                            wizard: this,
                        },
                        e
                    )
                );

                //-- Preload pages --
                if (this.config.preloadPages) {
                    po.load(false);
                }
                this.pages[e.id] = po;
            }
            if (e.type === "finisher") {
                this.finishers[e.id] = new uva.wizard.Finisher(
                    jQuery.extend(
                        {
                            router: this.router,
                            wizard: this,
                        },
                        e
                    )
                );
            }
            this.h.on(`next-${e.id}`, self);
            this.h.on(`skip-${e.id}`, self);
            this.h.on(`previous-${e.id}`, self);
            this.h.on(`reset-${e.id}`, self);
            this.h.on(`show-${e.id}`, self);
        });

        for (let ev in this.config.on) {
            let event = this.config.on[ev],
                func = event["func"] ?? event,
                data = event["data"] ?? null,
                fn = func;

            if (typeof fn !== "function") fn = window[func];
            if (typeof fn !== "function") fn = eval(func);
            if (typeof fn !== "undefined" && typeof ev !== "undefined") {
                this.el.on(ev, { api: data }, fn);
            }
        }

        // add headers
        this.el.prepend(this.config.header);

        this.on("uw:afterrouteforward", jQuery.proxy(this._cbAfterRouteForward, this));
        this.on("uw:afterroutebackward", jQuery.proxy(this._cbAfterRouteBackward, this));
        this.router.routeForward();
    };

    // #strict
    uva.Wizard.prototype.nextPage = function () {
        var currentPage = this.router.getCurrentPage();

        this.h.trigger(`next-${currentPage.id}`, this);

        this.el.trigger("uw:beforenextpage", [this]);
        this.router.routeForward();
        this.el.trigger("uw:afternextpage", [this]);
    };

    // #strict
    uva.Wizard.prototype.skipPage = function () {
        var currentPage = this.router.getCurrentPage();

        this.h.trigger(`skip-${currentPage.id}`, this);

        this.el.trigger("uw:beforeskippage", [this]);
        this.router.routeForward(true);
        this.el.trigger("uw:afterskippage", [this]);
    };

    // #strict
    uva.Wizard.prototype.previousPage = function () {
        var currentPage = this.router.getCurrentPage();

        this.h.trigger(`previous-${currentPage.id}`, this);

        this.el.trigger("uw:beforepreviouspage", [this]);

        con && console.log("+++++++++++++++++++++ event +++++++++++++++++++++");
        this.router.routeBackward();
        this.el.trigger("uw:afterpreviouspage", [this]);
    };

    // #strict
    uva.Wizard.prototype.breadcrumbpreviousPage = function (e) {
        var page = this._getCurrentPage(),
            step = page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").index(e.target),
            last = page.config.wizard.config.renderTo
                .find("#wizard-breadcrumb li")
                .index(page.config.wizard.config.renderTo.find("#wizard-breadcrumb li").last());
        con && console.log("+++++++++++ breadcrumbpreviousPage ++++++++");
        if (step > 0) {
            for (let i = step; i <= last; i++) {
                this.previousPage();
            }
        }
    };

    // #strict
    uva.Wizard.prototype.getFinisher = function (id) {
        return this.finishers[id];
    };

    // #strict
    uva.Wizard.prototype.getLoading = function () {
        return this.el.hasClass("is-loading");
    };

    // #strict
    uva.Wizard.prototype.getPage = function (id) {
        return this.pages[id];
    };

    // #strict
    uva.Wizard.prototype.on = function (event, func) {
        this.el.on(event, func);
    };

    // #strict
    uva.Wizard.prototype.reset = function () {
        var currentPage = this.router.getCurrentPage();

        this.h.trigger(`reset-${currentPage.id}`, this);

        this.h.l("Reset UVA Wizard");

        this.scrollTop();

        this.config = { ...this.configOrigin };
        this.init();
    };

    // #strict
    uva.Wizard.prototype.scrollTop = function () {
        this.h.l("+++ Scroll Top Wizard +++");

        if (this.config.scrollTop) {
            var e = this.config.renderTo.parent(),
                to_anchor = this.config.scrollToAnchor,
                scroll_wrapper = "html,body",
                offset = this.config.scrollOffset,
                p = to_anchor ? e.offset().top : 0,
                s = parseInt(p, 10) + parseInt(offset, 10);
            e && jQuery(scroll_wrapper).animate({ scrollTop: s }, this.config.scrollSpeed, "swing");
        }
    };

    // #strict
    uva.Wizard.prototype.setConfig = function (cfg) {
        this.config = jQuery.extend(this.config, cfg);
    };

    // #strict
    uva.Wizard.prototype.setLoading = function (isLoading) {
        if (isLoading == true) {
            this.el.addClass("is-loading");
            this.el.prepend(
                "<div class='wizard-is-loading'><div class='spinner-border text-primary' role='status' aria-hidden='true'></div></div>"
            );

            this.h.l("## hide nav ##");
            this.navEl.attr("style", "display: none !important");
        } else {
            this.el.removeClass("is-loading");
            this.el.children(".wizard-is-loading").remove();

            this.h.l("## show nav ##");
            this.navEl.attr("style", "");
        }
    };
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var CONST_UVA_HELPER_DEBUG = false,
        BOOTSTRAP = false,
        idIndex = 1,
        pageIdIndex = 1,
        storeIdIndex = 1;

    // #strict
    UVA.wpwizard.log = function (type, msg) {
        console.log("[" + type + "]: " + msg);
    };

    // #strict
    function get_single_route(pageEl, classes) {
        var routings = [];

        classes.forEach((e) => {
            pageEl.find(`.uva-wizard-${e}`).each(function () {
                const routeEl = {
                    value: jQuery(this).data("value"),
                    target: jQuery(this).data("target"),
                    trigger: pageEl.data("page-id"),
                };

                routings.push(routeEl);
            });
        });
        return routings;
    }

    // #strict
    function get_multi_route(pageEl, classes) {
        var routings = [];

        classes.forEach((e) => {
            var targets = pageEl.find(`.uva-wizard-${e}`).data("routings");

            targets != "" &&
                jQuery.each(targets, function (key, data) {
                    const routeEl = {
                        value: key,
                        target: data,
                        trigger: pageEl.data("page-id"),
                    };

                    routings.push(routeEl);
                });
        });
        return routings;
    }

    // #strict
    UVA.wpwizard.getButtonRouting = (p, e) => get_single_route(p, e);
    UVA.wpwizard.getRadioRouting = (p, e) => get_single_route(p, e);
    UVA.wpwizard.getCheckboxRouting = (p, e) => get_single_route(p, e);

    UVA.wpwizard.getSelectRoutings = (p, e) => get_multi_route(p, e);
    UVA.wpwizard.getTextfieldRouting = (p, e) => get_multi_route(p, e);

    /**
     * Retrieves the data from a single store finisher
     */
    // #strict
    UVA.wpwizard.getStoreFinisherData = function (storeFinisher, wizardId) {
        var o,
            sfEl = jQuery(storeFinisher),
            obj = {
                id: sfEl.data("finisher-id"),
                query: sfEl.data("finisher-query"),
                type: "finisher",
                pageCss: sfEl.attr("class"),
                finishertype: sfEl.data("finisher-type"),
                finishWorkflow: sfEl.data("finish-workflow") == 1,
            };

        //-- Form submit --
        if (obj.finishertype == "form-submit") {
            o = {
                action: sfEl.data("finisher-target"),
                method: "POST",
            };
            if (sfEl.data("finisher-ajax")) {
                obj.finishertype = "ajax-form";
                obj.attributes = {
                    "ajax-form": o,
                };
            } else {
                obj.attributes = {
                    "form-submit": o,
                };
            }
        }

        //-- Redirect --
        if (obj.finishertype == "redirect") {
            obj.attributes = {
                redirect: {
                    target: sfEl.data("finisher-target"),
                },
            };
        }

        //-- HTML --
        if (obj.finishertype == "html") {
            o = {
                action: sfEl.data("finisher-target"),
                method: "POST",
            };
            obj.attributes = {
                "ajax-form": sfEl.data("finisher-ajax") ? o : null,
                html: {
                    content: sfEl.html(),
                    contentEl: sfEl,
                },
            };
        }

        //-- Additional settings --
        // if (sfEl.data("page-hide-next")) obj.hideNextButton = true;
        // if (sfEl.data("page-hide-skip")) obj.hideSkipButton = true;
        // if (sfEl.data("page-hide-reset")) obj.hideResetButton = true;
        // if (sfEl.data("page-hide-submit")) obj.hideSubmitButton = true;
        // if (sfEl.data("page-hide-previous")) obj.hidePreviousButton = true;
        // if (sfEl.data("page-hide-navigation-text")) obj.hideNavigationText = true;

        // if (sfEl.data("page-custom-next")) obj.customNextButton = true;
        // if (sfEl.data("page-custom-skip")) obj.customSkipButton = true;
        // if (sfEl.data("page-custom-reset")) obj.customResetButton = true;
        // if (sfEl.data("page-custom-submit")) obj.customSubmitButton = true;
        // if (sfEl.data("page-custom-previous")) obj.customPreviousButton = true;
        // if (sfEl.data("page-custom-navigation-text")) obj.customNavigationText = true;

        obj.hideNextButton = sfEl.data("page-hide-next");
        obj.hideSkipButton = sfEl.data("page-hide-skip");
        obj.hideResetButton = sfEl.data("page-hide-reset");
        obj.hideSubmitButton = sfEl.data("page-hide-submit");
        obj.hidePreviousButton = sfEl.data("page-hide-previous");
        obj.hideNavigationText = sfEl.data("page-hide-navigation-text");

        obj.customNextButton = sfEl.data("page-custom-next");
        obj.customSkipButton = sfEl.data("page-custom-skip");
        obj.customResetButton = sfEl.data("page-custom-reset");
        obj.customSubmitButton = sfEl.data("page-custom-submit");
        obj.customPreviousButton = sfEl.data("page-custom-previous");
        obj.customNavigationText = sfEl.data("page-custom-navigation-text");

        //-- Custom --
        if (obj.finishertype == "custom") obj.finisherfunction = sfEl.data("finisher-function");

        obj.finisherHistory = sfEl.data("finisher-history");
        obj.finisherHistoryId = sfEl.data("finisher-history-id");

        return obj;
    };

    /**
     * Retrieves the data from a single store page
     */
    // #strict
    UVA.wpwizard.getStorePageData = function (storePage, wizardId) {
        var router = [],
            cSelector,
            tmpRouting = {},
            tmpRoutings = {},
            pageId = "page-id-" + pageIdIndex++,
            customConfigObj = {},
            spEl = jQuery(storePage),
            customConfig = spEl.data("page-custom-config") == "" ? {} : spEl.data("page-custom-config"),
            pageObject = {
                id: spEl.data("page-id"),
                type: "page",
                src: "local",
                triggerType: spEl.data("page-type"),
                triggerAttribute: "data-value",
                contentSelector: "#" + wizardId + " #" + pageId,
                contentCss: "",
                pageCss: "",
                wizardId: wizardId,
                pageId: pageId,
            },
            config = {};

        spEl.attr("id", pageId);

        pageObject.breadcrumb = spEl.data("page-breadcrumb");
        pageObject.stage = spEl.data("page-stage");
        pageObject.stageMax = spEl.data("page-stage-max");

        if (pageObject.triggerType == "button") {
            const classes = ["button", "imagebutton", "containerbutton"];
            tmpRoutings = UVA.wpwizard.getButtonRouting(spEl, classes);

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = ["button"];
        }

        if (pageObject.triggerType == "textfield" || pageObject.triggerType == "textarea") {
            const classes = ["textfield"];
            tmpRoutings = UVA.wpwizard.getTextfieldRouting(spEl, classes);

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = ["input[type=text]", "textarea"];
        }

        if (pageObject.triggerType == "select") {
            const classes = ["taxselect", "postselect"];
            tmpRoutings = UVA.wpwizard.getSelectRoutings(spEl, classes);

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = ["select"];
        }

        if (pageObject.triggerType == "radio") {
            const classes = ["radiobutton"];
            tmpRoutings = UVA.wpwizard.getRadioRouting(spEl, classes);

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = ["input[type=radio]"];
        }

        if (pageObject.triggerType == "checkbox") {
            const classes = ["checkbox"];
            tmpRoutings = UVA.wpwizard.getCheckboxRouting(spEl, classes);

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = ["input[type=checkbox]"];
        }

        if (pageObject.triggerType == "all") {
            var classes = [];

            tmpRoutings = [];

            classes = ["button", "imagebutton", "containerbutton"];
            jQuery.merge(tmpRoutings, UVA.wpwizard.getButtonRouting(spEl, classes));

            classes = ["textfield"];
            jQuery.merge(tmpRoutings, UVA.wpwizard.getTextfieldRouting(spEl, classes));

            classes = ["taxselect", "postselect"];
            jQuery.merge(tmpRoutings, UVA.wpwizard.getSelectRoutings(spEl, classes));

            classes = ["radiobutton"];
            jQuery.merge(tmpRoutings, UVA.wpwizard.getRadioRouting(spEl, classes));

            classes = ["checkbox"];
            jQuery.merge(tmpRoutings, UVA.wpwizard.getCheckboxRouting(spEl, classes));

            pageObject.triggerAttribute = "value";
            pageObject.triggerSelector = [
                "button",
                "input[type=text]",
                "textarea",
                "select",
                "input[type=radio]",
                "input[type=checkbox]",
            ];
        }

        //-- Loop through custom routers --
        if (Array.isArray(tmpRoutings)) {
            tmpRoutings.forEach((e) => router.push(e));
        }

        //-- Extern --
        if (["extern", "contact-form"].includes(pageObject.triggerType)) {
            cSelector = spEl.data("page-extern-selector");
            pageObject.src = spEl.data("page-extern-url");
            pageObject.pageCss = spEl.attr("class");
            pageObject.contentSelector = cSelector == "" ? "form" : cSelector;
            pageObject.contentCss = spEl.data("page-extern-css");
        }

        // //-- Contact form --
        // if (pageObject.triggerType == "contact-form") {
        //     cSelector = spEl.data("page-extern-selector");
        //     pageObject.src = spEl.data("page-extern-url");
        //     pageObject.pageCss = spEl.attr("class");
        //     pageObject.contentSelector = cSelector == "" ? "form" : cSelector;
        //     pageObject.contentCss = spEl.data("page-extern-css");
        // }

        //-- Additional settings --
        // if (spEl.data("page-hide-next")) pageObject.hideNextButton = true;
        // if (spEl.data("page-hide-skip")) pageObject.hideSkipButton = true;
        // if (spEl.data("page-hide-reset")) pageObject.hideResetButton = true;
        // if (spEl.data("page-hide-submit")) pageObject.hideSubmitButton = true;
        // if (spEl.data("page-hide-previous")) pageObject.hidePreviousButton = true;
        // if (spEl.data("page-hide-navigation-text")) pageObject.hideNavigationText = true;

        // if (spEl.data("page-custom-next")) pageObject.customNextButton = true;
        // if (spEl.data("page-custom-skip")) pageObject.customSkipButton = true;
        // if (spEl.data("page-custom-reset")) pageObject.customResetButton = true;
        // if (spEl.data("page-custom-submit")) pageObject.customSubmitButton = true;
        // if (spEl.data("page-custom-previous")) pageObject.customPreviousButton = true;
        // if (spEl.data("page-custom-navigation-text")) pageObject.customNavigationText = true;

        // if (spEl.data("page-custom-navigation")) pageObject.customNavigation = true;

        pageObject.hideNextButton = spEl.data("page-hide-next");
        pageObject.hideSkipButton = spEl.data("page-hide-skip");
        pageObject.hideResetButton = spEl.data("page-hide-reset");
        pageObject.hideSubmitButton = spEl.data("page-hide-submit");
        pageObject.hidePreviousButton = spEl.data("page-hide-previous");
        pageObject.hideNavigationText = spEl.data("page-hide-navigation-text");

        pageObject.customNextButton = spEl.data("page-custom-next");
        pageObject.customSkipButton = spEl.data("page-custom-skip");
        pageObject.customResetButton = spEl.data("page-custom-reset");
        pageObject.customSubmitButton = spEl.data("page-custom-submit");
        pageObject.customPreviousButton = spEl.data("page-custom-previous");
        pageObject.customNavigationText = spEl.data("page-custom-navigation-text");

        pageObject.customNavigation = spEl.data("page-custom-navigation");

        // pageObject.containerCustomCss = spEl.data("container-customcss");
        // if (pageObject.customNavigation) {
        pageObject.navigation = {
            nextButton: spEl.data("nextbutton"),
            skipButton: spEl.data("skipbutton"),
            resetButton: spEl.data("resetbutton"),
            submitButton: spEl.data("submitbutton"),
            previousButton: spEl.data("previousbutton"),
            navigationText: spEl.data("navigationtext"),

            nextCss: spEl.data("nextcss"),
            skipCss: spEl.data("skipcss"),
            resetCss: spEl.data("resetcss"),
            submitCss: spEl.data("submitcss"),
            previousCss: spEl.data("previouscss"),
            navigationTextCss: spEl.data("navigation-textcss"),

            containerNextCss: spEl.data("container-nextcss"),
            containerSkipCss: spEl.data("container-skipcss"),
            containerResetCss: spEl.data("container-resetcss"),
            containerSubmitCss: spEl.data("container-submitcss"),
            containerPreviousCss: spEl.data("container-previouscss"),
            containerNavigationTextCss: spEl.data("container-navigation-textcss"),

            containerCustomCss: spEl.data("container-customcss"),

            isnavigation: spEl.data("isnavigation"),
        };
        // }

        // if (spEl.data("page-multi-value")) pageObject.multiValue = true;
        // if (spEl.data("page-forward-on-click")) pageObject.forwardOnClick = true;

        pageObject.description = spEl.data("page-description");

        pageObject.multiValue = spEl.data("page-multi-value");
        pageObject.forwardOnClick = spEl.data("page-forward-on-click");

        //-- Basic routing (at the end!) --
        if (spEl.data("page-target")) {
            tmpRouting = {
                value: "*",
                target: spEl.data("page-target"),
                trigger: pageObject.id,
            };

            router.push(tmpRouting);
        }

        //-- Merge custom settings --
        // if (typeof customConfig === "string" || customConfig instanceof String) {
        //     if (customConfig != "") customConfigObj = JSON.parse(customConfig);
        // } else {
        //     customConfigObj = customConfig;
        // }
        //-- Additional page configuration --
        customConfigObj =
            typeof customConfig === "string" || customConfig instanceof String
                ? JSON.parse(customConfig)
                : customConfig;

        if (typeof customConfigObj !== "undefined") {
            pageObject = jQuery.extend(customConfigObj, pageObject);
        }

        //-- Validation --
        if (router.length < 1 && CONST_UVA_HELPER_DEBUG) {
            UVA.wpwizard.log("VALIDIERUNG", "Keine Routing-Optionen für Seite " + pageObject.id + " gefunden.");
        }

        config = {
            page: pageObject,
            router: router,
        };

        // console.log("| wp-wizard.js |||||||||||||||||||||||||||||||||||  Page " + pageId + " ||||||||||||||||||||||||||||||||||||||||||||||");
        // console.log("+++ Config +++");
        // console.log(config);
        return config;
    };

    /**
     * Handling a single store
     */
    // #strict
    UVA.wpwizard.initWizardFromStore = function (store) {
        var wizard,
            wizardCfg,
            customConfigObj,
            sEl = jQuery(store),
            wizardId = "wizard-" + idIndex++,
            wizardStoreId = "wizard-store-" + storeIdIndex++,
            id = sEl.data("id"),
            startPageId = sEl.data("first-page"),
            pages = [],
            header = [],
            router = [],
            customRouter = sEl.data("custom-router") == "" ? [] : sEl.data("custom-router"),
            customPages = sEl.data("custom-pages") == "" ? [] : sEl.data("custom-pages"),
            customConfig = sEl.data("custom-config") == "" ? {} : sEl.data("custom-config"),
            wizardCss = sEl.data("classname"),
            wizardEl = jQuery(`<div id="wizard-${id}" class="${wizardCss ? wizardCss : ""}">`),
            disallowedClasses = [
                "wp-block-columns",
                "wp-block-column",
                "wp-block-image",
                "to-align-align-top",
                "to-just-just-between",
                "to-column-gap-10",
                "row",
            ],
            navigation = {
                nextButton: sEl.data("nextbutton"),
                skipButton: sEl.data("skipbutton"),
                resetButton: sEl.data("resetbutton"),
                submitButton: sEl.data("submitbutton"),
                previousButton: sEl.data("previousbutton"),
                navigationText: sEl.data("navigationtext"),

                nextCss: sEl.data("nextcss"),
                skipCss: sEl.data("skipcss"),
                resetCss: sEl.data("resetcss"),
                submitCss: sEl.data("submitcss"),
                previousCss: sEl.data("previouscss"),
                navigationTextCss: sEl.data("navigation-textcss"),

                containerNextCss: sEl.data("container-nextcss"),
                containerSkipCss: sEl.data("container-skipcss"),
                containerResetCss: sEl.data("container-resetcss"),
                containerSubmitCss: sEl.data("container-submitcss"),
                containerPreviousCss: sEl.data("container-previouscss"),
                containerNavigationTextCss: sEl.data("container-navigation-textcss"),

                containerCustomCss: sEl.data("container-customcss"),

                navigationCss: sEl.data("navigationcss"),

                formCss: sEl.data("formcss"),
            },
            breadcrumbsVisible = sEl.data("breadcrumbsvisible"),
            breadcrumbsCss = sEl.data("breadcrumbscss"),
            breadcrumbCss = sEl.data("breadcrumbcss"),
            indicatorsVisible = sEl.data("indicatorsvisible"),
            indicatorsCss = sEl.data("indicatorscss"),
            indicatorCss = sEl.data("indicatorcss"),
            scrollTop = sEl.data("scrolltop"),
            scrollOffset = sEl.data("scrolloffset"),
            scrollToAnchor = sEl.data("scrolltoanchor"),
            scrollSpeed = sEl.data("scrollspeed");
        wizardEl.insertAfter(sEl);

        if (sEl.data("debug") == 1) {
            CONST_UVA_HELPER_DEBUG = false;
            con = false;
        }

        if (sEl.data("bootstrap") == 1) {
            BOOTSTRAP = true;
        }

        //-- Loop through header --
        sEl.find(".uva-wizard-header").each(function () {
            header.push(this);
        });

        //-- Loop through pages --
        sEl.find(".uva-wizard-page").each(function () {
            var sp = UVA.wpwizard.getStorePageData(this, wizardStoreId);
            const p = sp.page;

            pages.push(p);
            sp.router.forEach((e) => {
                //ToDo: Validation
                router.push(e);
            });
        });

        //-- Loop through finishers --
        sEl.find(".uva-wizard-finisher").each(function (index) {
            const f = UVA.wpwizard.getStoreFinisherData(this, wizardStoreId);

            pages.push(f);
        });

        //-- Loop through custom pages --
        customPages.forEach((e) => {
            //ToDo: Validation
            pages.push(e);
        });

        //-- Loop through custom routers --
        customRouter.forEach((e) => {
            //ToDo: Validation
            router.push(e);
        });

        sEl.attr("id", wizardStoreId);

        wizardCfg = {
            preloadPages: true,
            items: pages,
            header: header,
            router: router,
            startPageId: startPageId,
            renderTo: wizardEl,
            wizardCss: wizardCss,
            disallowedClasses: disallowedClasses,
            id: id,

            navigation: navigation,
            indicatorsVisible: indicatorsVisible,
            indicatorsCss: indicatorsCss,
            indicatorCss: indicatorCss,
            breadcrumbsVisible: breadcrumbsVisible,
            breadcrumbsCss: breadcrumbsCss,
            breadcrumbCss: breadcrumbCss,

            scrollTop: scrollTop,
            scrollOffset: scrollOffset,
            scrollToAnchor: scrollToAnchor,
            scrollSpeed: scrollSpeed,
        };

        //-- Additional wizard configuration --
        customConfigObj =
            typeof customConfig === "string" || customConfig instanceof String
                ? JSON.parse(customConfig)
                : customConfig;

        if (typeof customConfigObj !== "undefined") {
            wizardCfg = jQuery.extend(customConfigObj, wizardCfg);
        }

        wizard = new uva.Wizard(wizardCfg);
        return wizard;
    };

    var wizardStores = jQuery(".uva-wizard");

    wizardStores.each(function () {
        const w = UVA.wpwizard.initWizardFromStore(this);
        con && console.log(`#################### WIZARD ####################`);
        UVA.wpwizard.activeWizards.push(w);
    });
});
